import { React, useEffect } from "react";
import store from "../../../store";
import useState from 'react-usestateref';
import classes from './AssessmentID.module.scss';
import { Link } from "react-router-dom";

//MUI Imports
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function AssessmentId({onUpdate, project, schema}) {

  let [fields, setFields] = useState()
  let [dateFields, setDateFields] = useState()
  let [screenData, setScreenData] = useState({})
  let [screenContent, setScreenContent] = useState()

  function onChange(key, value){
    let screenDataClone = JSON.parse(JSON.stringify(screenData))
    screenDataClone[key] = value
    setScreenData(screenDataClone)
    onUpdate("assessmentID", screenDataClone);

  }

  useEffect(() => {
    if(schema && project){
      setScreenData(project.entries.assessmentID);
      setScreenContent(schema.screenContent.assessmentID);
      setFields(fields);
      setDateFields(dateFields)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[schema, project])

  return (
    <div>
      {(
        project && screenContent
        ?
          <Box className={`content_wrapper__inner`}>
            <Box className={`${classes.AssessmentID} gain_content_container`}>
              <section className={`${classes.AssessmentID__form_container} gain_content_container__form_container`}>
              {  
                schema.entryOptions.screen.assessmentID.fields.map((element, index) => {
                  switch (element.type) {
                    case "Text":
                      return (
                        <>
                          <TextField id="standard-basic" 
                            label={
                              <>
                                {element.label}
                                {element.toolTip && 
                                  <Tooltip title={<span dangerouslySetInnerHTML={{__html:element.toolTip}}/>}>
                                    <InfoOutlinedIcon sx={{
                                        height:"20px",
                                        width:"20px",
                                        marginLeft:"8px"
                                    }} 
                                    />
                                  </Tooltip>
                                }
                              </>
                            } 
                            variant="standard"
                            className={`form_input ${classes.AssessmentID__text_field}`}
                            key={index}
                            fullWidth
                            inputProps={{ maxLength: 40 }}
                            value={screenData[element.key] || ''}
                            onChange={(e) => {onChange(element.key, e.target.value.toString())}}
                          />
                        </>
                      )
                    case "TextArea":
                        return (
                          <TextField id="standard-basic" 
                            label={
                              <div className={`${classes.AssessmentID__label_tooltip}`}>
                                {element.label}
                                {element.toolTip && 
                                  <Tooltip title={<span dangerouslySetInnerHTML={{__html:element.toolTip}}/>}>
                                    <InfoOutlinedIcon sx={{
                                        height:"20px",
                                        width:"20px",
                                        marginLeft:"8px"
                                    }} 
                                    />
                                  </Tooltip>
                                }

                              </div>
                            } 
                            variant="standard"
                            className={`form_input`}
                            key={index}
                            fullWidth
                            multiline={true}
                            cols={50}
                            rows={7}
                            value={screenData[element.key] || ''}
                            onChange={(e) => {onChange(element.key, e.target.value.toString())}}
                          />
                        )
                    default:
                      return ("")
                  }
                })
              }

                <div className={`${classes.AssessmentID__date_container}`}>
                  <>
                  <div className={`dates`}>
                    <p className={`redColor`}><strong>{screenContent.dateHeading}</strong></p>
                  </div>
                  {
                    schema.entryOptions.screen.assessmentID.fields.map((element, index) => {
                      switch (element.type) {
                        case "Date":
                          return (
                            <LocalizationProvider key={index} dateAdapter={AdapterDateFns}>
                              <DatePicker
                                label={element.label}
                                value={screenData[element.key] || null} 
                                onChange={(newValue) => {onChange(element.key, newValue.toString())}}
                                renderInput={(params) => 
                                  <TextField 
                                    {...params}
                                    variant="standard"
                                    className={`${classes.AssessmentID__date_picker}`} 
                                  />
                                }
                              />
                            </LocalizationProvider>
                          )
                        default:
                          return ("")
                      }
                    })
                  }
                  </>
                </div>
                <Link className={"inline_button inline_button__small"} to={`${process.env.PUBLIC_URL}/project/${project.projectId}/${store.getState().pages.screening.slug}`}>
                  <Button variant="contained"><AddIcon /> Create Project</Button>
                </Link>
              </section>
              <section className={`${classes.AssessmentID__guidance} gain_content_container__guidance`}>
                <p className={`subtitle_copy`}>{screenContent.description.heading}</p>
                <p className={`small_copy`}> {screenContent.description.body}</p>
              </section>
            </Box>
          </Box>
        :
        ""
      )}

    </div>
  );
}
export default AssessmentId